import { render, staticRenderFns } from "./AddPinBatch.vue?vue&type=template&id=7b72ff1e"
import script from "./AddPinBatch.vue?vue&type=script&lang=js"
export * from "./AddPinBatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports